import React, { useEffect } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { setTwoToneColor } from '@ant-design/icons';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@iso/config/theme/theme.config';
import AppLocale from '@iso/config/translation';

export default function AppProvider({ children }) {
  const { language } = useSelector((s) => s.LanguageSwitcher);
  const { themeName } = useSelector((s) => s.ThemeSwitcher.changeThemes);
  const currentAppLocale = AppLocale[language];

  const isDark = String(themeName).toLowerCase().includes('dark');

  const antdThemeConfig = {
    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: '#0278b5',
      colorInfo: '#0278b5',
      colorSuccess: '#6dbf68',
      colorWarning: '#f59e0b',
      colorError: '#e5484d',
    },
  };

  return (
    <ConfigProvider locale={currentAppLocale.antd} theme={antdThemeConfig}>
      <SyncTwoToneWithAntD />
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <ThemeProvider theme={themes[themeName]}>{children}</ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  );
}

function SyncTwoToneWithAntD() {
  const { token } = antdTheme.useToken();

  useEffect(() => {
    setTwoToneColor([token.colorPrimary, token.colorPrimaryBg]);
  }, [token.colorPrimary, token.colorPrimaryBg]);

  return null;
}
